import { copyToClipboard } from "@/utils/copy-to-clipboard";
import type { DesignDiscipline } from "@/data/design-disciplines";
import s from "./style.module.css";
export interface Input {
    sections: DesignDiscipline[];
    sidebarRef: () => HTMLDivElement;
    activeId: string;
    onIntersect: (s: string) => void;
}

<const/{ sidebarRef, sections, activeId, onIntersect }=input>
<const/sectionRefs: Array<() => HTMLElement>=[]>

<div class=s.main>
    <div class=s.intro>
        <h2>Our design disciplines</h2>
        <p>
            Explore how our teams work together to support our buyers and
            sellers.
        </p>
    </div>
    <for|section| of=sections>
        <section/sectionRef
            class=s.section
            data-active=`${activeId === section.id}`
            id=section.id>
            <div class=s.header>
                <div>
                    <h3>${section.title}</h3>
                    <icon-button
                        class=s.copyButton
                        size="medium"
                        onClick() {
                            copyToClipboard(
                                `${window.location.href}#${section.id}`,
                            );
                        }>
                        <icon-link-20/>
                    </icon-button>
                </div>
            </div>
            <div class=s.mainContent>
                <h4>
                    <em>${section.jobTitle}</em>
                    ${" "}${section.shortDescription}
                </h4>
                <p>${section.longDescription}</p>
            </div>
            <quote-carousel quotes=section.quotes/>
        </section>
        <script>
            sectionRefs.push(sectionRef);
            setTimeout(() => {
                const top = sectionRef().getBoundingClientRect().top;
                if (Math.abs(top) < 100) {
                    onIntersect(sectionRef().id);
                }
            }, 100);
        </script>
    </for>
</div>
<script>
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) return;
            onIntersect(entry.target.id);
            const parent = sidebarRef().firstElementChild;
            const link = sidebarRef().querySelector(
                `a[data-id="${entry.target.id}"]`,
            );
            if (!parent || !link) return;
            if (window.innerWidth > 960) return;
            const padding = 24;

            // ensure layout is stable before measuring
            requestAnimationFrame(() => {
                const parentRect = parent.getBoundingClientRect();
                const linkRect = link.getBoundingClientRect();
                const delta = linkRect.left - parentRect.left; // distance from parent's left edge to link's left edge
                const desired = parent.scrollLeft + delta - padding; // desired absolute scroll position

                // clamp to allowed scroll range
                const maxScroll = Math.max(
                    0,
                    parent.scrollWidth - parent.clientWidth,
                );
                const target = Math.max(0, Math.min(desired, maxScroll));
                parent.scrollTo({
                    left: target,
                    behavior: "smooth",
                });
            });
        },
        {
            rootMargin: "-40% 0px -60% 0px",
        },
    );
    sectionRefs.forEach((sect) => {
        observer.observe(sect());
    });
    $signal.onabort = () => {
        sectionRefs.forEach((sect) => {
            observer.unobserve(sect());
        });
        observer.disconnect();
    };
</script>
